import type { FeaturePhase, FeatureVersion } from '@/src/types/featureExperience'

/** Secondary line beside the sidebar toggle — emphasizes switching while both versions are offered. */
export function sidebarNavigationResolvedDescription(version: FeatureVersion, phase: FeaturePhase): string {
  if (phase === 'available') {
    return version === 'next'
      ? 'New navigation (BHYBE rail). Toggle off for classic anytime.'
      : 'Classic navigation (Materio sidebar). Toggle on for new anytime.'
  }

  return version === 'next'
    ? 'BHYBE rail, horizontal sub-navigation, and updated layout.'
    : 'Original Materio sidebar, app bar, and classic layout.'
}

/** Collapsed rail switch tooltip — richer copy when rollout allows both versions. */
export function sidebarNavigationCollapsedSwitchTooltip(currentVersion: FeatureVersion, phase: FeaturePhase): string {
  if (phase === 'available') {
    return currentVersion === 'next'
      ? 'On new navigation — toggle off for classic.'
      : 'On classic navigation — toggle on for new.'
  }

  return currentVersion === 'next' ? 'Using new navigation — switch to Classic' : 'Using classic navigation — try New'
}
